import React from 'react';

const Detail = () => (
  <div>
    <h2>Detail page</h2>
    <p>If you are seeing this is due to you navigated from List page.</p>
  </div>
);

export default Detail;
